var _circle, _circle2, _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfographicDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4632_112543)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30.3334,
    r: 20,
    fill: "url(#paint0_linear_4632_112543)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4632_112543",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 40,
    height: 41
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30.3334,
    r: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4632_112543)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4999 48.3333C29.4999 34.7333 16.8332 31.6667 11.9999 31.8333C7.16657 32 15.4999 61.8334 15.4999 61.8334C29.1666 63 53.4999 61.9333 41.4999 48.3333Z",
    fill: "#6BA5DF",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.7173 82.4931C-58.4282 44.3969 -29.302 50.5783 -14.2912 41.4709C2.73713 31.1401 13.6861 30.2654 22.3965 33.7006C23.732 34.2274 25.0153 34.8564 26.2594 35.5668M152.303 98.3333C113.419 44.198 93.4195 67.1005 72.3571 64.4779C66.608 63.7622 61.7283 62.1141 57.4299 59.92M57.4299 59.92C54.7052 59.8109 47.8564 60.4722 42.2601 63.9856M57.4299 59.92C56.1159 59.2488 54.8557 58.5269 53.6423 57.7643M53.6423 57.7643C44.9442 56.8281 36.9726 61.6272 23.3895 64.4771M53.6423 57.7643C52.3429 56.9479 51.0965 56.0863 49.8923 55.1916M49.8923 55.1916C42.84 54.4574 31.947 59.92 20.2984 62.5219M49.8923 55.1916C49.0068 54.5342 48.1444 53.8584 47.3011 53.1703M10.41 63.9856C33.9199 58.5392 39.8065 52.2341 47.3004 53.1703C46.3081 52.3616 45.3428 51.5352 44.3974 50.7012M9.39316 63.4726C27.5588 58.007 32.2964 50.7012 44.3982 50.7012C44.0388 50.384 43.6824 50.0669 43.3292 49.7474M43.3292 49.7474C26.2056 48.5524 25.4715 56.8957 5.26683 63.4719M43.3292 49.7474C42.6956 49.1768 42.0705 48.6039 41.4507 48.0317M41.4507 48.0317C23.3895 45.3208 18.3047 58.7281 -1.68795 64.4771M41.4507 48.0317C40.7181 47.3552 39.9946 46.6793 39.275 46.0089M39.275 46.0089C9.39239 46.0089 18.8254 53.1703 -1.68795 59.92C-14.047 63.9856 -21.9463 54.7646 -42.2178 63.4726M39.275 46.0089C38.3711 45.1657 37.4757 44.3316 36.581 43.5145M-47.6097 64.4771C-34.9343 52.0966 -13.6054 63.4726 0.71274 54.237C20.3614 41.5631 29.5348 43.2212 36.5818 43.5145C35.9413 42.9301 35.3015 42.3541 34.6595 41.7896M34.6595 41.7896C34.6595 41.7896 14.7805 37.1388 -6.79958 52.6772C-18.9735 61.4437 -38.1921 52.0698 -50.8636 63.9856M34.6595 41.7896C33.7763 41.014 32.8901 40.2614 31.9931 39.541M31.9931 39.541C31.9931 39.541 14.2613 33.2075 -8.65808 49.7474C-20.4319 58.2443 -43.7161 52.0698 -55.8194 63.9856M31.9931 39.541C31.2029 38.9059 30.4042 38.2961 29.594 37.7163M29.594 37.7163C29.594 37.7163 14.7359 32.5717 -1.68795 43.2726C-26.7516 59.602 -41.6487 48.9794 -62.5092 65.1245M29.594 37.7163C28.508 36.9399 27.3998 36.218 26.2594 35.5668M26.2594 35.5668C26.2594 35.5668 10.41 29.6887 -7.93619 44.0713C-20.5909 53.9912 -45.5877 49.0439 -62.8963 63.9856M22.3965 33.7013C0.711972 30.1433 -8.65808 44.837 -43.7161 52.0705C-55.1221 56.0909 -61.5869 58.6474 -65.6541 64.4779",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-86.7173 78.7206C-48.3969 34.3778 -34.8268 49.1398 -14.2912 37.6993C36.4842 9.41174 33.1205 57.321 72.0921 62.1746C93.1546 64.798 114.956 45.1886 152.303 94.5609",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.5581 75.6283C-47.2377 31.2855 -33.4649 46.4046 -13.132 34.607C36.7733 5.65053 35.0377 54.7947 74.0093 59.6483C95.0717 62.271 116.89 43.6438 155.773 97.779",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.5581 72.9412C-42.8157 29.1944 -33.2068 43.4234 -12.874 31.6258C37.0313 2.66929 35.6774 51.9801 74.649 56.833C95.7115 59.4556 116.89 40.9559 155.773 95.0911",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.5581 70.3821C-40.7683 27.0192 -34.0347 40.7921 -13.3854 28.8109C36.5198 -0.145563 36.7011 49.037 75.6727 53.8906C96.7352 56.514 116.891 38.3975 155.774 92.5336",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-85.6807 66.4294C-47.8057 29.4499 -33.9054 38.2325 -13.2576 26.2513C35.425 -1.99555 37.0854 46.2217 76.057 51.0753C97.1195 53.6979 116.89 36.2219 155.773 90.3572",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87 63.0787C-49.9813 28.8071 -33.9061 35.1022 -13.2576 23.1218C35.4251 -5.12505 37.0854 43.0922 76.057 47.945C97.1195 50.5684 122.163 34.9978 161.047 89.133",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87 58.4999C-52.5971 26.4516 -36.8674 36.1926 -13.7475 21.35C33.6173 -9.05644 37.0854 40.0824 76.057 44.9352C97.1195 47.5586 122.163 31.9879 161.047 86.1232",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-87 54.9687C-52.5971 22.9203 -36.8674 32.6613 -13.7475 17.8187C33.6173 -12.5877 37.5393 38.0802 76.5109 42.9338C97.5734 45.5572 120.855 30.1147 161.047 82.5919",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.25 50.7251C-49.8471 18.6768 -39.9356 32.0388 -13.7477 15.2271C31.8032 -14.0151 37.02 37.7709 75.9917 42.6245C92.8717 44.7273 97.5564 29.1765 113.921 42.6245C130.286 56.0725 173.53 57.0448 173.53 57.0448",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.25 47.8574C-49.8471 15.8099 -39.4871 28.9607 -13.2984 12.1489C32.2525 -17.0932 37.5845 35.6029 76.5561 40.4557C93.4362 42.5584 97.809 25.8542 115.577 40.4557C133.345 55.0572 173.53 54.1763 173.53 54.1763",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.25 45.3986C-49.8471 13.3503 -39.4871 26.5019 -13.2984 9.68937C32.2525 -19.5528 37.8195 33.1364 76.7911 37.9892C93.6712 40.0919 97.2438 27.1262 111.911 35.5225C126.577 43.9188 152.376 49.8314 172.401 47.3854",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-82.0869 39.5534C-47.684 7.50586 -41.6615 25.3643 -15.4728 8.55261C30.078 -20.6895 39.2 30.8569 78.1716 35.7105C95.0517 37.8132 97.245 26.3589 111.912 34.7551C126.579 43.1514 153.2 47.5081 173.225 45.0621",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.9717 36.6089C-46.5687 4.56053 -40.5463 22.419 -14.3576 5.60728C31.1933 -23.6349 39.4973 28.5904 78.4682 33.444C95.3483 35.546 98.2489 25.0478 112.916 33.444C127.582 41.8403 154.314 44.5628 174.34 42.1168",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.9717 34.2751C-46.5687 2.22751 -42.2497 17.0763 -14.3576 3.27426C41.1255 -24.1816 39.975 24.7637 78.9466 29.6173C95.8267 31.7193 99.3655 23.932 114.032 32.3283C128.698 40.7245 154.314 42.2297 174.34 39.7837",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.9717 27.6253C-46.5687 -4.42306 -41.954 11.0079 -14.3576 -3.3763C42.5862 -33.057 38.6334 20.543 77.6703 24.8329C92.1827 26.428 99.983 18.3604 116.583 27.8634C133.183 37.3663 154.313 35.58 174.339 33.134",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.9717 22.43C-46.5687 -9.61829 -43.4661 2.4366 -14.3576 -8.57154C49.1247 -32.5792 38.6334 15.3478 77.6703 19.6377C92.1827 21.2328 99.983 13.1652 116.583 22.6681C133.183 32.171 154.313 30.3847 174.339 27.9387",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.9717 18.0745C-46.5687 -13.9738 -43.4661 -1.91816 -14.3576 -12.9271C49.1247 -36.9347 38.6334 10.9923 77.6703 15.2822C92.1827 16.8772 99.983 8.80967 116.583 18.3126C133.183 27.8155 154.313 26.0292 174.339 23.5832",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.9717 13.6443C-46.5687 -18.404 -43.4661 -6.34834 -14.3576 -17.3572C49.1247 -41.3649 38.6334 6.56208 77.6703 10.852C92.1827 12.4471 99.983 4.37873 116.583 13.8824C133.183 23.3853 154.313 21.599 174.339 19.153",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-79.4946 8.84453C-45.0917 -23.2038 -41.9891 -11.1481 -12.8805 -22.1571C50.6017 -46.1647 40.1104 1.76227 79.1481 6.05218C93.6605 7.64726 101.46 -0.420307 118.061 9.08261C134.661 18.5855 155.792 16.7992 175.818 14.3532",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-78.3862 4.03151C-43.9841 -28.0161 -40.8807 -15.9612 -11.7722 -26.9693C51.7101 -50.9769 41.2188 -3.04998 80.2565 1.23992C94.7689 2.835 102.568 -5.23257 119.169 4.27035C135.769 13.7733 156.9 11.987 176.925 9.54095",
    stroke: "white",
    strokeWidth: 0.8
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 38.8H25.25C25.0511 38.8 24.8603 38.721 24.7197 38.5803C24.579 38.4397 24.5 38.2489 24.5 38.05V21.55C24.5 21.3511 24.579 21.1603 24.7197 21.0197C24.8603 20.879 25.0511 20.8 25.25 20.8H34.25L39.5 26.05V38.05C39.5 38.2489 39.421 38.4397 39.2803 38.5803C39.1397 38.721 38.9489 38.8 38.75 38.8Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.25 20.8002V26.0502H39.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29.0501V35.0501",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 32.8001L32 35.0501L34.25 32.8001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4632_112543",
    x: 2,
    y: 4.33337,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4632_112543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4632_112543",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4632_112543",
    x1: 20.4209,
    y1: 16.4319,
    x2: 42.5686,
    y2: 43.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "#3068BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographicDownload);
export default __webpack_public_path__ + "static/media/InfographicDownload.6e02bc0d3565b8c0655e1a236b7819fa.svg";
export { ForwardRef as ReactComponent };